import { render, staticRenderFns } from "./BoardBilling.vue?vue&type=template&id=4c552438&scoped=true&"
import script from "./BoardBilling.vue?vue&type=script&lang=js&"
export * from "./BoardBilling.vue?vue&type=script&lang=js&"
import style0 from "./BoardBilling.vue?vue&type=style&index=0&id=4c552438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c552438",
  null
  
)

export default component.exports